import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import ptbr from './locales/ptbr.json';
import es from './locales/es.json';

i18n.use(LanguageDetector).use(initReactI18next).init({
  debug: false,
  returnObjects: true,
  fallbackLng: 'en',
  resources: {
    en,
    ptbr,
    es,
  },
});
